export async function readMessageStream(
  stream: ReadableStream,
  onNew?: (chunk: string) => void,
) {
  const reader = stream.getReader()
  const decoder = new TextDecoder()
  const chunks: string[] = []

  // eslint-disable-next-line no-constant-condition
  while (true) {
    const { done, value } = await reader.read()
    if (done) break
    if (value) {
      const chunk = decoder.decode(value)
      chunks.push(chunk)
      onNew?.(chunk)
    }
  }
  const text = chunks.join('')
  return formatStream(text)
}

export const formatStream = (token: string) => {
  const splitRes = token.split(`\n\n`).filter(Boolean)
  const formatResArr = splitRes.map((i: string) => {
    const c = JSON.parse(i.replace('data: ', ''))
    return c.event === 'MESSAGE' ? c.message.content : ''
  })
  return formatResArr.join('')
}
